// extracted by mini-css-extract-plugin
module.exports = {"bookshelf":"BookDetailUserBookshelves__bookshelf","bookshelfTitle":"BookDetailUserBookshelves__bookshelfTitle"};